import { gql } from '@apollo/client';

export default gql`
  query ProductTaxReadiness($id: ID!) {
    product(id: $id) {
      id
      currentTaxProfile {
        id
        state
      }
      taxProfileReviews {
        id
        state
      }
      taxProfiles {
        id
        approvedAt
        commercialDescription
        createdAt
        productFamily
        state
        treatment
        taxComponents {
          allocationType
          allocationValue
          description
          id
          identifier
          taxjarProductTaxCode
        }
      }
    }
  }
`;
